import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Info.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: a }));
e.displayName = "InfoIcon";
const c = e;
export {
  c as Info,
  e as InfoIcon
};
